var Sesion;
(function (Sesion) {
    class Control {
        constructor(_dotnet, _minutes) {
            this.dotnet = _dotnet;
            document.removeEventListener('mousemove', () => this.reset());
            document.removeEventListener('keypress', () => this.reset());
            document.addEventListener('mousemove', () => this.reset());
            document.addEventListener('keypress', () => this.reset());
            if (_minutes <= 2) {
                this.millliseconds = 30 * 60 * 1000;
            }
            else {
                this.millliseconds = _minutes * 60 * 1000;
            }
            this.reset();
            this.interval = window.setInterval(() => this.actualizar(), 1000);
        }
        reset() {
            if (!this.modalIsOpen) {
                var startedValue = Date.now();
                sessionStorage.setItem("ST_SESION_STARTED", startedValue.toString());
            }
        }
        getDateStarted() {
            var raw = sessionStorage.getItem("ST_SESION_STARTED");
            return parseInt(raw);
        }
        forzarReset() {
            this.modalIsOpen = false;
            var startedValue = Date.now();
            sessionStorage.setItem("ST_SESION_STARTED", startedValue.toString());
        }
        actualizar() {
            let dateStarted = this.getDateStarted();
            let elapsed = Date.now() - dateStarted;
            let timeLeft = this.millliseconds - elapsed;
            if (timeLeft <= 0) {
                clearInterval(this.interval);
                this.dotnet.invokeMethodAsync("CerrarSesion");
                return;
            }
            let htmlEl = document.getElementById('tiempoSesion');
            if (htmlEl) {
                let totalSeconds = Math.round(timeLeft / 1000);
                let totalMinutes = Math.floor(totalSeconds / 60);
                let seconds = Utils.padZeros(Math.round(totalSeconds % 60), 2);
                let print = totalMinutes + ":" + seconds;
                htmlEl.innerHTML = print;
                let redLimit = 2 * 60 * 1000;
                if (timeLeft < redLimit) {
                    this.modalIsOpen = true;
                    this.dotnet.invokeMethodAsync("AbrirModal");
                }
            }
            let exp = localStorage.getItem("TOKEN_EXPIRATION_KEY");
            let leftToExp = (parseFloat(exp) * 1000) - Date.now();
            if (leftToExp < (50 * 1000)) {
                this.dotnet.invokeMethodAsync("RefreshToken");
            }
        }
    }
    Sesion.Control = Control;
    function iniciarControl(_dotnet, _minutes) {
        Sesion.Control.Actual = new Control(_dotnet, _minutes);
    }
    Sesion.iniciarControl = iniciarControl;
    function forzarReset() {
        Sesion.Control.Actual.forzarReset();
    }
    Sesion.forzarReset = forzarReset;
})(Sesion || (Sesion = {}));
